import React, { useEffect, useContext, useState } from "react";
import Axios from "axios";
import AppContext from "../../../context/store";
import PerformanceReport from "./PerformanceReport";
import Select from "../../../theme/CustomMUI/Select";

const AnalysisIndex = () => {
  const context = useContext(AppContext);
  const [analyticsData, setAnalyticsData] = useState(null);
  const [analysisRecords, setAnalysisRecords] = useState([]);
  const [selectedRecordId, setSelectedRecordId] = useState(null);
  const [allRecordsData, setAllRecordsData] = useState([]);

  const fetchAnalysis = async () => {
    try {
      const response = await Axios.get(`${context.api_endpoint}/company/analytics/company/ai-analytics`);
      if (response.data?.data?.records) {
        const records = response.data.data.records.map(record => ({
          value: record.id,
          label: new Date(record.created_at).toLocaleDateString('tr-TR')
        }));
        setAnalysisRecords(records);
        setAllRecordsData(response.data.data.records);

        // Son kaydı seç
        if (records.length > 0) {
          const lastRecord = response.data.data.records[records.length - 1];
          const parsedAnalysis = JSON.parse(lastRecord.analysis);
          setSelectedRecordId(lastRecord.id.toString());
          setAnalyticsData(parsedAnalysis);
        }
      }
    } catch (error) {
      console.error("Analytics data fetch error:", error);
    }
  };

  useEffect(() => {
    fetchAnalysis();
  }, []);

  const handleAnalysisChange = (value) => {
    const selectedRecord = allRecordsData.find(record => record.id.toString() === value);
    if (selectedRecord) {
      const parsedAnalysis = JSON.parse(selectedRecord.analysis);
      setSelectedRecordId(value);
      setAnalyticsData(parsedAnalysis);
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      {analyticsData && (
        <PerformanceReport
          data={analyticsData}
          analysisRecords={analysisRecords}
          selectedRecordId={selectedRecordId}
          onAnalysisChange={handleAnalysisChange}
        />
      )}
    </div>
  );
};

export default AnalysisIndex;
